import { forwardRef } from 'react';
import { Stack as MuiStack } from '@mui/material';
import { unstable_extendSxProp as extendSxProp } from '@mui/system';

// MUI v9 removed top-level system props from Stack (it only keeps direction,
// spacing, divider, useFlexGap, sx). This project sets justifyContent/alignItems
// and other shorthands directly on Stack. This compat wrapper folds the system
// shorthands back into `sx` while leaving Stack's own props (direction, spacing,
// divider, useFlexGap) untouched. Wired via a Vite alias on '@mui/material/Stack'.
const Stack = forwardRef(function Stack(props, ref) {
  return <MuiStack ref={ref} {...extendSxProp(props)} />;
});

export default Stack;
